// format date in yyyymmdd format
// see: https://spdlybra.nintendo.co.jp/confluence/pages/viewpage.action?pageId=1005079519
export function formatDate(unixTime: number) {
  const d = new Date(unixTime * 1000);
  const yearString = d
    .getFullYear()
    .toString()
    .padStart(4, '0');
  const monthString = (d.getMonth() + 1).toString().padStart(2, '0');
  const dateString = d
    .getDate()
    .toString()
    .padStart(2, '0');

  const resString = yearString + monthString + dateString;

  return resString;
}

// しんぶんのリクエストパラメータを整形
export function formatDateTime(unixTime: number) {
  const d = new Date(unixTime * 1000);
  const yearString = d
    .getFullYear()
    .toString()
    .padStart(4, '0');
  const monthString = (d.getMonth() + 1).toString().padStart(2, '0');
  const dateString = d
    .getDate()
    .toString()
    .padStart(2, '0');
  const hourString = d
    .getHours()
    .toString()
    .padStart(2, '0');
  const minuteString = d
    .getMinutes()
    .toString()
    .padStart(2, '0');

  return `${yearString}-${monthString}-${dateString} ${hourString}:${minuteString}`;
}
